/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { RepayUSDOptions, RepayUSDResponses } from '../types/RepayUSD'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Repay borrowed USD, then accrue and pay leverage interest
 * {@link /v1/positions/repay_usd}
 */
export function repayUSD<ThrowOnError extends boolean = true>(
  options: Options<RepayUSDOptions, ThrowOnError>,
): Unwrappable<RequestResult<RepayUSDResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'POST',
      url: '/v1/positions/repay_usd',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<RepayUSDResponses, ThrowOnError>>,
  )
}
